<template>
    <div :class="{ 'spacer-box': 1, 'fillout-hint': isFilloutHintShown}">
        <div class="cst-survey-card-button-bar">
            <button class="cst-survey-comment" v-if="question.review" @click="showFeedbackModal()">{{ $t("btnFeedback") }}</button>
            <button class="cst-survey-next-skip-btn" v-if="isNextButtonShown" :class="{'cst-survey-btn-disabled': !skippable}" :disabled="!skippable" @click="skipCard">{{ $t("btnNext") }}</button>
            <button class="cst-survey-next-skip-btn" v-if="isSkipButtonShown" @click="skipCard">{{ $t("btnSkip") }}</button>
            <div class="survey-comment-mobile-box" v-if="question.review">
                <button class="cst-survey-comment-mobile" @click="showFeedbackModal()">{{ $t("btnFeedback") }}<img class="arrow-icon" src="../assets/icon_arrow_up.svg" /></button>
            </div>
        </div>
        <div v-if="isFilloutHintShown" :class="{ 'comment-fillout-hint': 1, 'additional-button': isNextButtonShown || isSkipButtonShown }">
            <div class="comment-fillout-hint-content">
                <img class="comment-fillout-arrow" src="../assets/comment_hint_arrow.svg" />
                <span> {{ $t('txtSuggestFeedback') }} </span>
            </div>    
        </div>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    export default {
      props: [ 'question', 'skippable' ],
      methods: {
        showFeedbackModal: function () {
          eventHub.$emit('show-modal', {type: 'card-feedback-comment', id: 6, content: { title: this.question.group_title, group_id: this.question.group_id }})
        },
        skipCard: function () {
          eventHub.$emit('card-next')
        }
      },
      computed: {
        isFilloutHintShown: function () {
          return this.question.review && !Object.keys(this.$store.state.reviews).length
        },
        isNextButtonShown: function () {
          return this.question.type === 'text'
        },
        isSkipButtonShown: function () {
          return this.question.type === 'percent' && this.skippable
        }
      }
    }
</script>


<style lang="less" scoped>
    @import '../_theme';
    .additional-button {
        width: 66%;
    }
    .spacer-box {
        flex-grow: 10;
        position: relative;
        padding-bottom: 2em;
    }
    .cst-survey-card-button-bar {
        display: flex; 
        justify-content: center;
        margin-top: 1em;
        margin-bottom: 1em;
    }
    button.cst-survey-comment {
        .cst-survey-btn;
        //background-color: @secondary-button-color;
    }
    .cst-survey-next-skip-btn {
        .cst-survey-btn;
        background-color: rgba(0, 0, 0, 0);
        color: @main-button-color;
        &:hover {
            filter: saturate(130%);
            background-color: fade(@main-button-color, 5%);
        }
    }
    .cst-survey-next-skip-btn {
        display: none;
    }
    .survey-comment-mobile-box {
        display: none;
    }
    .cst-survey-comment-mobile {
        .cst-survey-btn;
        display: none;
    }
    .cst-survey-comment {
        display: none;
    }
    .survey-comment-mobile-box {
        max-width: 1200px;
        min-width: 400px;
        width: 50%;
    }
    .comment-fillout-hint {
        margin-top: 1em;
    }
    .comment-fillout-hint span {
        color:#909090;
        font-family: 'Architects Daughter', cursive;
    }    
    .comment-fillout-hint .comment-fillout-arrow {
        width: 3em;
        height: 3em;
        transform: scaleX(-1) rotate(-172deg);
        margin-left: 33%;
        display: block;
    }
    .comment-fillout-hint-content {
        display: flex;
        flex-direction: column;
        width: 50%;
        margin: 0 auto;
        text-align: center;
    }
    .comment-fillout-hint-content span {
        display: block;
        margin: 0 auto;
        transform: rotate(-5deg);
    }
    @media (min-width: 800px) {
        .comment-fillout-hint {
            display: block;
        }        
        .cst-survey-comment {
            display: block;
        }
        .cst-survey-next-skip-btn {
            display: block;
        }
        .cst-survey-comment-mobile {
            display: none;
        }
        .comment-fillout-hint-content span {
            width: 100%;
        }
    }
    @media (max-width: 800px) {
        .comment-fillout-hint {
            position: absolute;
            bottom: 3.5em;
            width: 22em;
        }
        .spacer-box.fillout-hint {
            padding-top: 3.5em;
        }
        .comment-fillout-hint-desktop {
            display: none;
        }        
         .comment-fillout-hint-content {
            flex-direction: column-reverse;
         }
        .comment-fillout-hint .comment-fillout-arrow {
            transform: scaleX(-1) rotate(-295deg);
            margin-left: 1em;
            margin-top: -0.5em;
        }

        .survey-comment-mobile-box {
            display: block;
            bottom: 0;
            width: 100%;
            z-index: 10;
            position: absolute;
        }
        .cst-survey-comment-mobile {
            display: block;
            margin: 0 auto;
        }
        .cst-survey-card-button-bar {
            margin-bottom: 3em;
        }
        .arrow-icon {
            width: 1em;
            height: 1em;
            margin-left: 1em;
        }

    }    

</style>

<style>
 /* .slide-enter-active .survey-comment-mobile-box, .slide-leave-active .survey-comment-mobile-box,
 .reverseslide-enter-active .survey-comment-mobile-box, .reverseslide-leave-active .survey-comment-mobile-box{
     display: none;
 } */
</style>


// WEBPACK FOOTER //
// src/components/CardButtonBar.vue